
<mat-card [appearance]="'filled'" [class]="bgClass()">

    <mat-card-content>

        <div class="grid-cols-[1fr_auto] grid gap-4">

            <div> <ng-content></ng-content> </div>

            <div class="w-full text-end">

                @if (type() === 'success') {
                <mat-icon class="icon-success">check_circle</mat-icon>}

                @if (type() === 'warning') {
                <mat-icon class="icon-warning">warning</mat-icon>}

                @if (type() === 'error') {
                <mat-icon class="icon-error">error</mat-icon>}

                @if (type() === 'information') {
                <mat-icon class="icon-information">info</mat-icon>}
            </div>

        </div>


    </mat-card-content>

</mat-card>

